import React from "react";

export default function Hero() {
  return (
    <section className="bg-white py-20 text-center px-4">
      <h1 className="text-4xl sm:text-5xl font-bold mb-4">Command Your Bar.</h1>
      <p className="text-lg sm:text-xl max-w-xl mx-auto mb-8">
        BarCommand helps you manage one or multiple bar & restaurant locations — all from one place.
        Sync employee data, streamline operations, and take control.
      </p>
    </section>
  );
}
